const labels = {
  applicant: 'Student',
  nameBn: 'Name in Bangla',
  nameEn: 'Name in English',
  father: 'Father',
  mother: 'Mother',
  present: 'Present address',
  permanent: 'Permanent address',
  guardian: 'Guardian',
  name: 'Name',
  relation: 'Relationship',
  phone: 'Phone',
  address: 'Address',
  sameAsPresent: 'Same as present address',
  occupation: 'Occupation',
  workAddress: 'Workplace',
  monthlyIncome: 'Monthly income',
  dob: 'Date of birth',
  nationality: 'Nationality',
  religion: 'Religion',
  transfer: 'Transfer details',
  isTransfer: 'Transfer applicant',
  prevInstitution: 'Previous institution',
  tcNo: 'Transfer certificate number',
  tcDate: 'Transfer certificate date',
  education: 'Academic history',
  exam: 'Examination',
  groupYear: 'Group and year',
  registration: 'Registration and session',
  centreSerial: 'Centre and roll',
  gpa: 'GPA',
  institution: 'Institution',
  board: 'Board',
  subjects: 'Subjects',
  compulsory: 'Compulsory subjects',
  optional: 'Optional subjects',
  declarations: 'Declarations',
  office: 'Office record',
  testRoll: 'Admission test roll',
  classRoll: 'Class roll',
  section: 'Section',
  admissionDate: 'Admission date',
  documentsChecked: 'Original documents checked',
  signedFormReceived: 'Signed form received',
  studentName: 'Student name'
};
export default function ApplicationSummary({
  value
}) {
  if (value === null || value === undefined || value === '') return <span>—</span>;
  if (typeof value !== 'object') return <span>{typeof value === 'boolean' ? value ? 'Yes' : 'No' : String(value)}</span>;
  if (!Object.keys(value).length) return <span className="text-muted">Not provided</span>;
  if (Array.isArray(value)) return <div className="space-y-2">{value.map((v, i) => <div key={i}><ApplicationSummary value={v} /></div>)}</div>;
  return <dl className="admission-summary space-y-2">{Object.entries(value).map(([k, v]) => <div key={k} className="border-l pl-3"><dt className="text-xs font-semibold text-muted">{labels[k] || k}</dt><dd className="text-sm"><ApplicationSummary value={v} /></dd></div>)}</dl>;
}
